import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {gtmEventPreFormOpen} from "../../tracking/google_tag_manager/gtm_event_pre_form_open";
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {RESERVATION_PLACEMENT_CONFIG} from "../constants/reservation_placement_config";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationPlacement} from "../types/ReservationPlacement";

export type ReservationGtmAction = "click" | "view" | "code_submit" | "resend" | "success" | "error" | "close";

export const gtmReservation = (action: ReservationGtmAction, placement: ReservationPlacement, label?: string) => {
    hitGoogleTagManager({
        event: "modal_reservation",
        event_action: action,
        event_category: RESERVATION_PLACEMENT_CONFIG[placement].gtmSourceSection ?? placement,
        ...(label ? {event_label: label} : {})
    });
};

export const gtmReservationStart = (request: IReservationRequest, offerName: string | null) => {
    const sourceSection = RESERVATION_PLACEMENT_CONFIG[request.placement].gtmSourceSection;

    if (sourceSection) {
        gtmEventPreFormOpen(InquiryButtonTypeName.FREE_RESERVATION, sourceSection, request.vendorName ?? "", offerName ?? "");
    }

    gtmReservation("click", request.placement, InquiryButtonTypeName.FREE_RESERVATION);
};
import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {gtmEventPreFormOpen} from "../../tracking/google_tag_manager/gtm_event_pre_form_open";
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {RESERVATION_PLACEMENT_CONFIG} from "../constants/reservation_placement_config";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationPlacement} from "../types/ReservationPlacement";

export type ReservationGtmAction = "click" | "view" | "code_submit" | "resend" | "success" | "error" | "close";

export const gtmReservation = (action: ReservationGtmAction, placement: ReservationPlacement, label?: string) => {
    hitGoogleTagManager({
        event: "modal_reservation",
        event_action: action,
        event_category: RESERVATION_PLACEMENT_CONFIG[placement].gtmSourceSection ?? placement,
        ...(label ? {event_label: label} : {})
    });
};

export const gtmReservationStart = (request: IReservationRequest, offerName: string | null) => {
    const sourceSection = RESERVATION_PLACEMENT_CONFIG[request.placement].gtmSourceSection;

    if (sourceSection) {
        gtmEventPreFormOpen(InquiryButtonTypeName.FREE_RESERVATION, sourceSection, request.vendorName ?? "", offerName ?? "");
    }

    gtmReservation("click", request.placement, InquiryButtonTypeName.FREE_RESERVATION);
};
